// src/components/RecentInvoicesSection.js
import React, { useState } from 'react';
import download from "../../assets/img/ico/download.svg";
// Si tu utilises une librairie d'icônes (comme react-icons), importe-les ici
// import { FiDownload, FiRefreshCw } from 'react-icons/fi'; // Exemple d'icônes

function RecentInvoicesSection({ invoices }) { // Assure-toi de recevoir les factures via les props
    const [selectedInvoicePeriod, setSelectedInvoicePeriod] = useState('Ce mois');
    // Idéalement, utilise un vrai composant de date range picker ici
    const [selectedInvoiceDateRange, setSelectedInvoiceDateRange] = useState('Sam.01 mars.25 - Dim.02 mars.25');

    const handleDownloadTable = () => {
        console.log('Télécharger le tableau des factures récentes');
        // Logique de téléchargement ici (par exemple, générer un fichier CSV/Excel)
    };

    const handleActionClick = (invoiceId, actionType) => {
        console.log(`Action '${actionType}' pour la facture ${invoiceId}`);
        // Logique pour télécharger une facture ou relancer/modifier
        // Si c'est une relance ou modification, cela ouvrirait probablement un modal ou redirigerait
    };


    const [selected, setSelected] = useState("Ce mois");
    const [open, setOpen] = useState(false);

    const options = ["90 derniers jours", "6 derniers mois", "Ce mois"];

    const handleSelect = (value) => {
        setSelected(value);
        setOpen(false);
        // ici tu pourrais trier ton tableau offer selon la valeur choisie
    };

    return (
        <div className="recent-invoices-section">
            <h2>Liste détaillée des factures récentes</h2>

            <div className="invoices-controls">

                <div className="custom-dropdown" onClick={() => setOpen(!open)}>
                    <button className="custom-dropdown-button">
                        {selected}
                        <i
                            className={`fa-solid fa-chevron-down ${open ? "rotate" : ""}`}
                        ></i>
                    </button>

                    {open && (
                        <ul className="custom-dropdown-menu">
                            {options.map((option) => (
                                <li
                                    key={option}
                                    onClick={() => handleSelect(option)}
                                    className={`custom-dropdown-item ${
                                        selected === option ? "active" : ""
                                    }`}
                                >
                                    {option}
                                    {selected === option && (
                                        <i className="fa-solid fa-check check-icon"></i>
                                    )}
                                </li>
                            ))}
                        </ul>
                    )}
                </div>

                {/* Placeholder pour le date picker */}
                <input
                    type="text"
                    value={selectedInvoiceDateRange}
                    onChange={(e) => setSelectedInvoiceDateRange(e.target.value)}
                    className="invoices-date-picker"
                    placeholder="Sélectionner une plage de dates"
                />
                {/* Icône de calendrier ici */}

                <button onClick={handleDownloadTable} className="btn icon">
                    {/* Icône de téléchargement ici, par exemple <FiDownload /> */}
                    <span className="icon-wrapper">
        <img src={download} alt="Icône de téléchargement"></img> {/* Ajout de l'attribut alt pour l'accessibilité */}
    </span>
                    Télécharger le tableau
                </button>
            </div>

            <div className="invoice-table-container"> {/* Nouveau conteneur pour le tableau stylisé */}
                <table>
                    <thead>
                    <tr>
                        <th>N° facture</th>
                        <th>Client</th>
                        <th>Date d'émission</th>
                        <th>Montant</th>
                        <th>Statut</th>
                        <th>Action</th> {/* Colonne pour les actions */}
                    </tr>
                    </thead>
                    <tbody>
                    {/* Mapper sur les données 'invoices' pour créer une ligne par facture */}
                    {invoices && invoices.length > 0 ? (
                        invoices.map((invoice, index) => (
                            // Il est préférable d'utiliser un ID unique si disponible, sinon l'index est une solution de repli
                            <tr key={invoice.id || index}>
                                <td>{invoice.number || `#${index + 1}`}</td> {/* Utilise invoice.number si existe */}
                                <td>{invoice.client}</td>
                                <td>{invoice.issueDate}</td> {/* Assumes invoice has an issueDate property */}
                                <td>{new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(invoice.amount)}</td> {/* Formatage du montant */}
                                <td>
                                <span className={`status-badge status-${invoice.status.toLowerCase().replace(/\s/g, '-')}`}>
                                    {invoice.status}
                                </span>
                                </td>
                                <td className="action-cell">
                                    {/* Icônes d'action */}
                                    {/* Par exemple: */}
                                    {/* <FiDownload className="action-icon" onClick={() => handleActionClick(invoice.id, 'download')} title="Télécharger la facture" /> */}
                                    {/* {invoice.status === 'En attente' && (
                                    <FiRefreshCw className="action-icon" onClick={() => handleActionClick(invoice.id, 'remind')} title="Relancer le client" />
                                )} */}
                                    {/* Placeholder avec des icônes */}
                                    {invoice.status !== 'En attente' && (
                                        <span className="action-icon-placeholder" onClick={() => handleActionClick(invoice.id || index, 'download')} title="Télécharger"><img src={download} alt="Télécharger" /></span>
                                    )}
                                    {invoice.status === 'En attente' && (
                                        <span className="action-icon-placeholder" onClick={() => handleActionClick(invoice.id || index, 'remind')} title="Relancer"><img src={download} alt="Relancer" /></span>
                                        )
                                    }
                                    {/* Ajoute d'autres icônes si besoin (modifier, voir, etc.) */}
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            {/* Cellule unique qui s'étend sur toutes les colonnes */}
                            <td colSpan="6" className="no-invoices-message">Aucune facture récente à afficher.</td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>

            {/* Les deux boutons en bas du tableau */}
            <div className="invoices-footer-actions">
                <button className="btn fill green">
                    {/* Icône ou texte */}
                    Rappel groupe - Retards de paiement
                </button>
                <button className="btn empty">
                    {/* Icône ou texte */}
                    Comparer avec le mois précédent
                </button>
            </div>

        </div>
    );
}

export default RecentInvoicesSection;